'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
/** Mount once near the root. Shares the open delay across tooltips. */
export function TooltipProvider({ delayDuration = 400, children, }) {
    return (_jsx(TooltipPrimitive.Provider, { delayDuration: delayDuration, children: children }));
}
/** Shows on hover and keyboard focus; Escape dismisses it. */
export function Tooltip({ content, children, side = 'top', align = 'center', ...state }) {
    return (_jsxs(TooltipPrimitive.Root, { ...state, children: [_jsx(TooltipPrimitive.Trigger, { asChild: true, children: children }), _jsx(TooltipPrimitive.Portal, { children: _jsx(TooltipPrimitive.Content, { side: side, align: align, sideOffset: 6, className: "mn-tooltip", children: content }) })] }));
}
//# sourceMappingURL=tooltip.js.map